import { NotImplementedError } from "../api/errors";
import { EventObject } from "../api/eventObject";
import { ActionQueue } from "./action";
import { CustomAction, TestCaseExceptionAction, TestCaseLogAction } from "./utilityActions";
//This should be the dumbest class that simply exposes the code exercise API.
export class World {
    constructor(testCase) {
        this._testCase = testCase;
    }
    log(message) {
        this._testCase.queueLogAction(message);
    }
    getMethodByName(name) {
        return this[name];
    }
}
export class TestCase {
    constructor(parameterData) {
        this._logText = "";
        this._logTextChangedEvent = new EventObject();
        this._error = null;
        this._erroredEvent = new EventObject();
        this._actionQueue = new ActionQueue();
        this._sceneNode = undefined;
        this._root = undefined;
        this._element = undefined;
        this._isDirty = false;
        //Evaluate
        this._evaluation = null;
        this._evaluatedEvent = new EventObject();
        this._parameterData = parameterData;
        this._actionQueue.startedEvent.add(this, this._onActionQueueStarted);
    }
    //--Rendering--
    //This is attached to the Scene to render.
    get sceneNode() {
        if (this._sceneNode == undefined) {
            this._sceneNode = this.createSceneNode();
        }
        return this._sceneNode;
    }
    createSceneNode() {
        throw new NotImplementedError();
    }
    get canvasWidth() {
        throw new NotImplementedError();
    }
    get canvasHeight() {
        throw new NotImplementedError();
    }
    //--User Code--
    //This is the "world" argument that users code against.
    get root() {
        if (!this._root) {
            this._root = this.createRoot();
        }
        return this._root;
    }
    createRoot() {
        throw new NotImplementedError();
    }
    get actionQueue() {
        return this._actionQueue;
    }
    dirty() {
        this._isDirty = true;
    }
    get isDirty() {
        return this._isDirty;
    }
    //--Code and Interactive Testing--
    //Something the user did caused an exception.
    handleError(error) {
        this._error = error;
        this._actionQueue.add(new TestCaseExceptionAction(this, error)); //Error might not be of type Error... which is annoying.
    }
    _onActionQueueStarted() {
        this.dirty();
    }
    stop() {
        this._actionQueue.stop();
    }
    get isSuccess() {
        throw new NotImplementedError();
    }
    //--Logging--
    //Puts a log action into the queue for later
    queueLogAction(message) {
        this._actionQueue.add(new TestCaseLogAction(this, message));
    }
    //Logs a line to the full log.
    log(message) {
        console.log(message);
        this._logText =
            this._logText.length !== 0 ? this._logText + "\n" + message : message;
        this._logTextChangedEvent.raise();
    }
    //The full log.
    get logText() {
        return this._logText;
    }
    //Raised when a new line is added to the log.
    //(string message)
    get logTextChangedEvent() {
        return this._logTextChangedEvent;
    }
    //--Errors--
    get error() {
        return this._error;
    }
    //(Error error)
    get erroredEvent() {
        return this._erroredEvent;
    }
    //--Interactive--
    getElement(document) {
        if (this._element == undefined) {
            this._element = this.createElement(document);
        }
        return this._element;
    }
    createElement(document) {
        throw new NotImplementedError();
    }
    get styleSheet() {
        throw new NotImplementedError();
    }
    get evaluatedEvent() {
        return this._evaluatedEvent;
    }
    evaluate() {
        let newEvaluation = this.isSuccess && this.error === null;
        if (newEvaluation != this._evaluation) {
            this._evaluation = newEvaluation;
            this._evaluatedEvent.raise();
        }
    }
    queueEvaluate() {
        this._actionQueue.add(new CustomAction(() => { this.evaluate(); }));
    }
    get evaluation() {
        return this._evaluation;
    }
}
